<script>
    import { createEventDispatcher } from "svelte";
    import { SIZE_MIN, SIZE_MAX } from "../../const";
    const dispatch = createEventDispatcher();

    export let value = 50;

    export let width = 0;
    export let height = 0;
    export let constraints;

    const MAX = 99;
    const MIN = 1;

    function onHeightChange(val) {
        dispatch("heightChange", val);
    }

    function onWidthChange(val) {
        dispatch("widthChange", val);
    }

    let minHeight = SIZE_MIN,
        maxHeight = SIZE_MAX,
        minWidth = SIZE_MIN,
        maxWidth = SIZE_MAX;

    $: {
        if (constraints) {
            minWidth = Math.ceil(constraints.min.width + 1);
            maxWidth = Math.ceil(constraints.max.width - 1);

            minHeight = Math.ceil(constraints.min.height + 1);
            maxHeight = Math.ceil(constraints.max.height - 1);
        } else {
            minWidth = SIZE_MIN;
            maxWidth = SIZE_MAX;

            minHeight = SIZE_MIN;
            maxHeight = SIZE_MAX;
        }
    }
</script>

<div class="module-calc-size">
    <div class="option-wide" id="option_size">
        <label class="align-content-left" for="module-size"
            ><span
                >Размер: <input
                    id="project-width"
                    type="number"
                    value={width}
                    on:change={(e) => onWidthChange(e.currentTarget.value)}
                    min={minWidth}
                    max={maxWidth}
                />
                x
                <input
                    id="project-height"
                    type="number"
                    value={height}
                    on:change={(e) => onHeightChange(e.currentTarget.value)}
                    min={minHeight}
                    max={maxHeight}
                />
            </span>
        </label>
        <div class="input-freesize">
            <input
                id="module-size"
                type="range"
                step="1"
                min={MIN}
                max={MAX}
                bind:value
                on:change={(e) => {
                    dispatch("sizeChange", value);
                }}
            />
        </div>
    </div>
</div>
